import { createAction, props } from '@ngrx/store';
import type { Step } from './wizard.reducer';

export const setSteps = createAction('[Wizard Steps] Set Steps', props<{ steps: Step[] }>());

export const setCurrentStep = createAction(
  '[Wizard Steps] Set Current Step',
  props<{ currentStep: Step }>()
);

export const setCompleteStep = createAction(
  '[Wizard Steps] Set Complete Step',
  props<{ index: number }>()
);
